export default "__VITE_ASSET___G4asQOE__"